import styled from 'styled-components';

export const Container = styled.div`
  padding: 25px 30px;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 1.25rem;
  }
`;

export const Label = styled.p`
  font-size: 14px;
`;
